export class PermissionService {
    static isAllowedTo(userlogged, keyprop) {
        let isallowed = true;
        if (userlogged.groups.length > 0)
            isallowed = userlogged.groups[0].defaultCanEverything;
        for (var i = 0; i < userlogged.permissions.length; i++) {
            let p = userlogged.permissions[i];
            if (p.permkey == keyprop) {
                isallowed = p.permvalue == 'true';
                break;
            }
        }
        return isallowed;
    }
}
